import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-lg">
              <i className="ri-hand-heart-line"></i>
            </span>
            <span className="font-heading font-bold text-lg">Insani Darul Hana</span>
          </div>
          <p className="text-sm text-secondary-100/80 leading-relaxed">
            {t('footer.tagline')}
          </p>
          <p className="mt-4 text-xs text-secondary-200/70">{t('footer.regNo')}</p>
        </div>

        <div>
          <h4 className="text-sm font-heading font-semibold text-white mb-4">
            {t('footer.quickLinks')}
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <a href="#home" className="text-secondary-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                {t('nav.home')}
              </a>
            </li>
            <li>
              <a href="#about" className="text-secondary-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                {t('nav.about')}
              </a>
            </li>
            <li>
              <a href="#programs" className="text-secondary-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                {t('nav.programs')}
              </a>
            </li>
            <li>
              <a href="#donate" className="text-secondary-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                {t('nav.donate')}
              </a>
            </li>
            <li>
              <a href="#contact" className="text-secondary-100/80 hover:text-accent-300 transition-colors cursor-pointer">
                {t('nav.contact')}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-heading font-semibold text-white mb-4">
            {t('footer.programs')}
          </h4>
          <ul className="space-y-2.5 text-sm text-secondary-100/80">
            <li>{t('programs.charity.title')}</li>
            <li>{t('programs.donation.title')}</li>
            <li>{t('programs.training.title')}</li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-heading font-semibold text-white mb-4">
            {t('footer.contact')}
          </h4>
          <ul className="space-y-3 text-sm text-secondary-100/80">
            <li className="flex items-start gap-2.5">
              <i className="ri-map-pin-2-line text-accent-300 mt-0.5"></i>
              <span>{t('contact.address')}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <i className="ri-phone-line text-accent-300"></i>
              <span>{t('contact.phone')}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <i className="ri-mail-line text-accent-300"></i>
              <span>{t('contact.email')}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-secondary-200/70">
          <span>
            © {new Date().getFullYear()} Persatuan Insani Darul Hana Kuching. {t('footer.rights')}
          </span>
          <span>{t('footer.regNo')}</span>
        </div>
      </div>
    </footer>
  );
}